import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DenunciarPage } from './denunciar';
import { DenunciarPageRoutingModule } from './denunciar-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DenunciarPageRoutingModule
  ],
  declarations: [
    DenunciarPage,
  ]
})
export class DenunciarModule { }
